import { render, staticRenderFns } from "./ProjectFiltersCommunityItem.vue?vue&type=template&id=4a1fc60e&scoped=true&"
import script from "./ProjectFiltersCommunityItem.vue?vue&type=script&lang=js&"
export * from "./ProjectFiltersCommunityItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1fc60e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
